import { render, staticRenderFns } from "./StKeyMessage.vue?vue&type=template&id=4526d12f"
import script from "./StKeyMessage.vue?vue&type=script&lang=ts"
export * from "./StKeyMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports